module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.4-117.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.4.md
// module id = 534
// module chunks = 277